import { LuTriangleAlert } from 'react-icons/lu'
import { isRouteErrorResponse, useRouteError } from 'react-router'
import { Button } from '../components/ui/Button.tsx'
import { EmptyState } from '../components/ui/EmptyState.tsx'

export function ErrorPage() {
  const error = useRouteError()
  const detail = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : 'Unexpected error'
  return (
    <div className="mx-auto max-w-[640px] px-4 py-16">
      <EmptyState
        icon={LuTriangleAlert}
        color="orange"
        title="Something went wrong"
        action={<Button onClick={() => window.location.reload()}>Reload</Button>}
      >
        {detail}
      </EmptyState>
    </div>
  )
}
